/*
 Reusable selectors for Canvas Form bodies data
*/
import {createSelector} from 'reselect';

const getFormBodySlice = (state) => state.formBodies || {};

export const getFormBodyByIdSlice = (state) => getFormBodySlice(state).byId || {};

export const getFormBodyById = (state, bodyId) => getFormBodyByIdSlice(state)[bodyId];

export const anyBodyHasUnsavedChanges = createSelector([getFormBodyByIdSlice], (byId) => {
	let hasUnsavedChanges = false;
	let bodyEntries = Object.entries(byId);
	let i = 0;

	while (!hasUnsavedChanges && i < bodyEntries.length) {
		let elementEntries = Object.entries(bodyEntries[i][1].elements);

		hasUnsavedChanges = elementEntries.some(([_, hasChanges]) => hasChanges);

		i++;
	}

	return hasUnsavedChanges;
});

export const bodyHasUnsavedChanges = (bodyData, elementName) => {
	if (elementName) {
		return bodyElementHasUnsavedChanges(bodyData, elementName);
	} else {
		return bodyHasAnyUnsavedChanges(bodyData);
	}
};

/**
 * Given a body slice, will return if there is any element with unsaved changes or not.
 * @param {object} bodyData the body slice holding the list of elements and its unsaved changes flags.
 * @returns {boolean} true if the body has any element with unsaved changes, otherwise false.
 **/
export const bodyHasAnyUnsavedChanges = (bodyData) => {
	let elementEntries = Object.values(bodyData?.elements || {});

	return elementEntries.some((elementHasChange) => elementHasChange);
};

/**
 * Given a body slice and an element name, will return if the desired element has unsaved changes or not.
 * @param {object} bodyData the body slice holding the list of elements and its unsaved changes flags.
 * @param {string} elementName the input key to look for inside the body data.
 * @returns {boolean} true if element has unsaved changes, otherwise false.
 **/
export const bodyElementHasUnsavedChanges = (bodyData, elementName) => {
	let elementEntries = Object.entries(bodyData?.elements || {});
	let element = elementEntries.find(([name, _]) => name === elementName);

	return element !== undefined && element[1];
};

export const getFormBodyDataBySectionId = (state, sectionId) => {
	return state.formBodyData?.find((fbd) => fbd.sectionId === sectionId)?.bodies;
};

export const selectFormBodyData = createSelector([(store) => store.formBodyData], (formBodyData) => formBodyData);

export const selectBodiesBySectionId = createSelector([selectFormBodyData, (store, sectionId) => sectionId], (formBodyData, sectionId) => {
	if (Array.isArray(formBodyData)) {
		const found = formBodyData.find((fbd) => fbd.sectionId === sectionId);

		if (found) {
			return found.bodies;
		}
	}

	return null;
});

//Gets all the actions binded from all selected options of all bodies within the desired section.
export const getSelectedOptionActionsBySectionId = (state, sectionId, actionFilter) => {
	let bodies = getFormBodyDataBySectionId(state, sectionId);
	let actions = [];

	bodies?.map((b) => {
		let selectedOptions = b?.optionsAndResponses?.filter((o) => {
			return o.bodySelectedOptionId > 0;
		});
		let bodyActions = actionFilter ? b.actions.filter((x) => actionFilter(x)) : b.actions;

		if (bodyActions?.length > 0) {
			bodyActions.map((a) => {
				if (selectedOptions.find((o) => o.bodyOptionId === a.formBodyOptionId)) {
					actions.push(a);
				}
			});
		}
	});

	return actions;
};

export const getOptionActionsBySectionId = (state, sectionId, actionFilter) => {
	let bodies = getFormBodyDataBySectionId(state, sectionId);
	let actions = [];

	bodies?.map((b) => {
		let bodyActions = actionFilter ? b.actions?.filter((x) => actionFilter(x)) : b.actions;
		if (bodyActions?.length > 0) {
			bodyActions.map((a) => {
				actions.push(a);
			});
		}
	});

	return actions;
};
